<div [ngStyle]="{'opacity': layerData?.locks.tint ? '0.5' : '1', 'pointer-events': layerData?.locks.tint ? 'none' : 'all' }" #container>

  <span [style.background]="currentColor" [cpToggle]="true" [cpDialogDisplay]="'inline'" [cpCancelButton]="false"
    [(colorPicker)]="currentColor" [cpOutputFormat]="'hex'" [cpAlphaChannel]="'disabled'" [cpWidth]="container.offsetWidth"></span>
</div>